<template>
    <div class="card">
        <div class="card-body">
            <h4 class="title text-primary mb-0">{{ __('Gender') }}</h4>
            <template v-if="loading">
                <Spinner spinner-type="grow" />
            </template>
            <template v-else-if="chartConfig">
                <div id="gender_render_div">
                    <Chart :options="chartConfig" />
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Spinner from '../../components/Spinner';
import { Chart } from 'highcharts-vue';

export default {
    components: {
        Spinner,
        Chart,
    },

    inject: ['selectedStatsWheelPath'],

    data() {
        return {
            loading: false,
            chartConfig: null,
        }
    },

    watch: {
        selectedStatsWheelPath: function (value) {
            if (value === 'Ambassador') {
                this.fetchCounts({ ambassador: true });
            } else if (value === 'Teacher') {
                this.fetchCounts();
            }
        },
    },

    mounted() {
        this.observe_visibility(this.$el, () => {
            this.fetchCounts();
        });
    },

    methods: {
        fetchCounts(params = {}) {
            this.loading = true;
            this.chartConfig = null;
            axios.get('/dashboard/gender-wise-user-count', { params })
                .then(({ data }) => {
                    this.initChart([{
                        data: [
                            [this.__('Male'), Number(data.counts.male_count)],
                            [this.__('Female'), Number(data.counts.female_count)],
                            [this.__('Others'), Number(data.counts.others_gender_count)],
                        ],
                    }]);
                })
                .catch(console.error)
                .finally(() => this.loading = false);
        },

        initChart(series) {
            const vm = this;
            this.chartConfig = {
                chart: {
                    type: 'pie',
                    height: '330px',
                    events: {
                        render: function () {
                            if (this.series.length !== 0) {
                                let total = 0;
                                this.series[0].data.forEach(item => {
                                    total += item.visible ? item.y : 0;
                                });

                                this.setTitle({
                                    text: `<span style="font-size: 24px">${vm.en_to_bn(total)}</span><br>
                                    <span style="font-size: 20px">${vm.__('Overall')}</span>`,
                                });
                            }
                        }
                    },
                },
                title: {
                    verticalAlign: 'middle',
                    floating: true,
                    y: 10,
                },
                legend: {
                    enabled: true,
                },
                plotOptions: {
                    series: {
                        borderWidth: 0,
                        colorByPoint: true,
                        type: 'pie',
                        size: '100%',
                        innerSize: '50%',
                        showInLegend: true,
                        dataLabels: {
                            enabled: false,
                        },
                    },
                },
                tooltip: {
                    formatter: function () {
                        return '<b>' + this.point.name + '</b>: ' + vm.en_to_bn(this.y);
                    },
                },
                colors: ['#008000', '#FF359B', '#B57EDC'],
                series: series,
                accessibility: {
                    enabled: false,
                },
                credits: {
                    enabled: false,
                },
            };
        },
    },
}
</script>